import { useEffect, useState } from "react";
import { MINUTE_MS } from "../logic/dayTime";

/**
 * Живият часовник на страницата: връща „сега" и се обновява в началото на
 * всяка минута (не на всеки 60 s от монтирането — иначе „19:10" би се сменило
 * чак в 19:10:59). Всеки тик се пренасочва към следващата граница на минута
 * (setTimeout, не setInterval), а при връщане към таба (visibilitychange /
 * focus) часовникът се засича веднага — браузърът приспива таймерите на
 * фонов таб и иначе „СЕГА" изостава с минути (освободена маса още изглежда
 * заета).
 */
export const useNow = (): number => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    let timeout: ReturnType<typeof setTimeout> | undefined;
    const tick = () => {
      clearTimeout(timeout);
      setNow(Date.now());
      timeout = setTimeout(tick, MINUTE_MS - (Date.now() % MINUTE_MS));
    };
    const onVisible = () => {
      if (document.visibilityState === "visible") tick();
    };
    timeout = setTimeout(tick, MINUTE_MS - (Date.now() % MINUTE_MS));
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", onVisible);
    return () => {
      clearTimeout(timeout);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", onVisible);
    };
  }, []);

  return now;
};
